import { useEffect, useState } from 'react';
import type { Template } from '@flashcard/shared';
import { api } from '../lib/api';

interface TemplateGalleryProps {
  onSelect: (template: Template) => void;
  selectedId?: string;
}

export function TemplateGallery({ onSelect, selectedId }: TemplateGalleryProps) {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .getTemplates()
      .then(setTemplates)
      .catch((e: any) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Lade Templates…</p>;
  if (error) return <p className="error">Fehler: {error}</p>;
  if (templates.length === 0) return <p>Keine Templates verfügbar.</p>;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem' }}>
      {templates.map((t) => (
        <div
          key={t.id}
          onClick={() => onSelect(t)}
          style={{
            border: selectedId === t.id ? '2px solid var(--accent)' : '1px solid var(--border)',
            borderRadius: '8px',
            overflow: 'hidden',
            cursor: 'pointer',
            background: 'var(--surface)',
            transition: 'border-color 0.2s, box-shadow 0.2s',
            boxShadow: selectedId === t.id ? 'var(--glow)' : 'none',
          }}
        >
          {t.previewUrl && (
            <img src={t.previewUrl} alt={t.name} style={{ width: '100%', height: '140px', objectFit: 'cover' }} />
          )}
          <div style={{ padding: '0.75rem' }}>
            <strong style={{ display: 'block', marginBottom: '0.25rem' }}>{t.name}</strong>
            <small className="text-muted">{t.productUid}</small>
            {t.description && (
              <p className="text-muted" style={{ fontSize: '0.8rem', marginTop: '0.25rem' }}>{t.description}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
